export function hasUsCriminalChecks(additionalChecks) {
  if (!Array.isArray(additionalChecks)) return false;
  return additionalChecks.some(
    (check) => check?.type === "us-criminal-v1" || check?.type === "us-criminal-v2"
  );
}

export function buildVerificationNavBarItems(verificationInfo, params, options = {}) {
  if (!verificationInfo || !params?.id) return [];

  const { canCompleteRiskAssessment = false } = options;
  const id = params.id;
  const type = verificationInfo.type || "";
  const isTranche2 = type.includes("tranche2_v1");

  const showSanctions = type.includes("sanctions") || isTranche2;
  const showAdverseMedia = type.includes("adverse_media") || isTranche2;
  const showUsCriminal =
    type.includes("us_criminal_checks") ||
    hasUsCriminalChecks(verificationInfo.additional_checks);
  const showResponse = !!verificationInfo.response_id;
  const showRiskAssessment = isTranche2 && canCompleteRiskAssessment;

  const items = [{ label: "KYC", link: `/verification/${id}` }];

  if (showSanctions) {
    items.push({ label: "PEP/Sanctions", link: `/verification/sanctions/${id}` });
  }
  if (showAdverseMedia) {
    items.push({ label: "Adverse Media", link: `/verification/adverse/${id}` });
  }
  if (showResponse) {
    items.push({
      label: "Response",
      link: `/verification/${id}/response/${verificationInfo.response_id}`,
    });
  }
  if (showUsCriminal) {
    items.push({ label: "US Criminal Checks", link: `/verification/us-criminal-v1/${id}` });
  }
  if (showRiskAssessment) {
    items.push({ label: "Risk Assessment", link: `/verification/risk-assessment/${id}` });
  }

  return items.length === 1 ? [] : items;
}
